import { Route, Routes } from 'react-router-dom';
import LoginPage from './features/login/LoginPage';
import ApplicationPage from './features/application/ApplicationPage';
import { HelmetProvider } from 'react-helmet-async';
import EventPage from './features/event/pages/EventPage';

const App = () => {
  return (
    <div className="App">
      <HelmetProvider>
        <Routes>
          <Route index element={<LoginPage/>}></Route>
          <Route path="/application/*" element={<ApplicationPage/>}></Route>
          <Route path="/event/*" element={<EventPage/>}></Route>
        </Routes>
      </HelmetProvider>
    </div>
  );
};

export default App;
